module.exports = __webpack_public_path__ + "img/detail-bg-hen.0e9e94ce.png";